import api from "@/lib/api";

export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function subscribePush() {
  if (!pushSupported()) {
    throw new Error("Notifications non supportées. Sur iPhone : ajoutez d'abord le site à l'écran d'accueil (Partager → Sur l'écran d'accueil), puis rouvrez-le depuis l'icône.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Autorisation de notification refusée. Vérifiez les réglages de votre navigateur/téléphone.");
  }
  const registration = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const existing = await registration.pushManager.getSubscription();
  const subscription =
    existing ||
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    }));
  await api.post("/admin/push/subscription", subscription.toJSON());
  return subscription;
}

export async function unsubscribePush() {
  const subscription = await getCurrentSubscription();
  if (subscription) {
    await api.delete("/admin/push/subscription", { data: { endpoint: subscription.endpoint } });
    await subscription.unsubscribe();
  }
}
